import React, {
    createContext,
    useCallback,
    useContext,
    useLayoutEffect,
    useState
} from 'react'

interface IChildren {
    children: JSX.Element | JSX.Element[]
}

const Ctx = createContext<boolean>(true)

export const useConnectivityContext = () => {
    const isOnline = useContext(Ctx)

    return { isOnline }
}

const ConnectivityContext = ({ children }: IChildren) => {
    const [isOnline, setOnline] = useState(true)

    const offline = useCallback(() => {
        setOnline(false)
    }, [])

    const online = useCallback(() => {
        setOnline(true)
    }, [])

    const updateNetworkState = useCallback(() => {
        window.addEventListener('offline', offline)
        window.addEventListener('online', online)

        return () => {
            window.removeEventListener('offline', offline)
            window.removeEventListener('online', online)
        }
    }, [offline, online])

    useLayoutEffect(updateNetworkState, [updateNetworkState])

    return <Ctx.Provider value={isOnline}>{children}</Ctx.Provider>
}

export default ConnectivityContext
